import mod from "-!./iconInfoSvg.js?vue&type=script&lang=js&"; export default mod; export * from "-!./iconInfoSvg.js?vue&type=script&lang=js&"